
import { PropType } from 'vue'

import { IdfAccordion } from '@invivodf/ui-kit'
import { formatDate, formatDateInterval, formatList, formatMeasureUnit } from '@invivodf/front-seller-l10n'
import QuotaDashboard from '@/contexts/quota-dashboard/domain/quota-dashboard'
import PWarningMessage from '../../../../../presenters/PWarningMessage.vue'
import PQuotaCard from '../PQuotaCard/PQuotaCard.vue'
import PQuotaProgress from '../PQuotaProgress/PQuotaProgress.vue'
import PHierarchicalList from '../PHierarchicalList/PHierarchicalList.vue'

export default {
  name: 'PQuota',
  components: { PQuotaCard, PQuotaProgress, IdfAccordion, PHierarchicalList, PWarningMessage },
  props: {
    quota: {
      type: Object as PropType<QuotaDashboard>,
      required: true,
    },
  },
  methods: { formatDate, formatDateInterval, formatList, formatMeasureUnit },
}
